import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Opa",
  "description": "",
  "published": "2006-06-10T00:00:00.000Z",
  "redirect_from": ["/blog/opa/swizec/403"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`VÄeraj, ko sem šel domov od paÄ nekje, sem ob cesti opazil dva modela, ki sta se pregovarjala prek manjšega avtotrka, bel Ford inu nek temen avto, Äe se prav spomnim, sem pomilsil nekaj v stilu, heh, nekje moje starosti. Ozrl sem se in se usral. Še pred letom dni bi si mislil, da sta velika starca, ker Å¾e imata avto in podobne stvari. A se res Å¾e tako staram ali kaj? To mora biti nekaj narobe...`}</p>
    <p>{`Uglavnem, kljub temu, da sem kot kaÅ¾e prestrašen starÄek, to, kot kaÅ¾e, še ne pomeni, da sem kaj bolj moder inu ne len, saj sem dobrešenj del zadnjih dveh dni porabil s prebiranjem `}<a parentName="p" {...{
        "href": "http://www.reallifecomics.com"
      }}>{`tegale arhiva`}</a>{`. To seveda pomeni, da nisem risal stripa. Res je folk, niti ena sama Ärta stripa še ni narisana, kar neizbeÅ¾no pomeni, da ne bo izšel v kratkem, kot bi lahko bilo priÄakovati po prebiranju neke dotiÄne izjave, ampak da bo izšel nihÄe ne ve kdaj. Res je, da bo e vedno ob pravem Äasu, saj se bo v mesecu juniju, vendar kdaj v tem mesecu vam pa ne morem povedat.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      